import React from 'react';

// COMPONENT
import SvgMask from '../_Helpers/SvgMask';

// TYPE
export type AnswerState = 'correct' | 'incorrect';

interface MarkingPillProps {
	state?: AnswerState;
	isActive?: boolean;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const MarkingPill: React.FC<MarkingPillProps> = ({ state = 'default', className = '', onClick, isActive }) => {
	return (
		<button className={`assessment-marking-pill ${state} ${isActive ? 'active' : ''}`} onClick={onClick}>
			{state === 'correct' ? (
				<div className="assessment-answer-icon-wrapper">
					<SvgMask className="status-icon" path={'/svg/tick-success-thin.svg'} width={48} height={48} />
				</div>
			) : (
				<div className="assessment-answer-icon-wrapper">
					<SvgMask className="status-icon" path={'/svg/tick-danger-thin.svg'} width={48} height={48} />
				</div>
			)}
		</button>
	);
};

export default MarkingPill;
